const extractPageData = (response) => {
  const data = response?.data || response || {};
  const registros = Array.isArray(data.registros) ? data.registros : [];
  const totalRegistros = Number(data.totalRegistros) || 0;
  return { registros, totalRegistros };
};

export const fetchPremiacaoPaginatedList = async ({
  fetchPage,
  baseFilters,
  pageSize,
  maxRecords
}) => {
  const registros = [];
  let paginaAtual = 1;
  let totalRegistros = 0;

  while (registros.length < maxRecords) {
    const response = await fetchPage({
      ...baseFilters,
      PaginaAtual: paginaAtual,
      QuantidadePorPagina: pageSize
    });
    const pagina = extractPageData(response);
    totalRegistros = pagina.totalRegistros || totalRegistros;

    if (pagina.registros.length === 0) {
      break;
    }

    const remaining = maxRecords - registros.length;
    registros.push(...pagina.registros.slice(0, remaining));

    const fetchedAll = pagina.registros.length < pageSize
      || registros.length >= totalRegistros
      || registros.length >= maxRecords;

    if (fetchedAll) {
      break;
    }

    paginaAtual += 1;
  }

  return {
    registros,
    totalRegistros,
    truncado: totalRegistros > registros.length
  };
};
